/**
 * Guests (and other tiers without diet_plan.find_recipes) normally see
 * ingredients blurred. Some entry points are invitations to that recipe and
 * must show it in full: the home recipe widget (Sameer) and Magazine CTAs.
 *
 * Both set the same skip on <Recipe />. The widget does it via React Router
 * state (in-app tap). Magazine does it via ?src=magazine on the universal
 * link (email / cold open).
 */

export const RECIPE_OPEN_ACCESS_PARAM = "src";
export const RECIPE_OPEN_ACCESS_MAGAZINE = "magazine";
export const RECIPE_OPEN_ACCESS_WIDGET = "widget";

/**
 * Navigation state for history.push. One flag drives the Recipe screen;
 * fromRecipeWidget is kept for the original widget callers/tests.
 */
export function recipeOpenAccessState(source) {
  const state = {
    skipFindRecipesPermission: true,
    recipeOpenSource: source,
  };
  if (source === RECIPE_OPEN_ACCESS_WIDGET) {
    state.fromRecipeWidget = true;
  }
  return state;
}

/** True when this recipe screen should skip diet_plan.find_recipes. */
export function shouldSkipFindRecipesPermission(location) {
  const state = location?.state;
  if (
    state?.skipFindRecipesPermission === true ||
    state?.fromRecipeWidget === true
  ) {
    return true;
  }

  try {
    const params = new URLSearchParams(location?.search || "");
    return params.get(RECIPE_OPEN_ACCESS_PARAM) === RECIPE_OPEN_ACCESS_MAGAZINE;
  } catch {
    return false;
  }
}

/**
 * Keep ?src=magazine on a normalized /recipe/{id} path so a cold open from
 * mail still unlocks after login / deep-link replay.
 */
export function recipePathWithOpenAccess(pathname, searchParams) {
  if (!pathname) return pathname;
  try {
    const params =
      searchParams instanceof URLSearchParams
        ? searchParams
        : new URLSearchParams(searchParams || "");
    if (params.get(RECIPE_OPEN_ACCESS_PARAM) === RECIPE_OPEN_ACCESS_MAGAZINE) {
      return `${pathname}?${RECIPE_OPEN_ACCESS_PARAM}=${RECIPE_OPEN_ACCESS_MAGAZINE}`;
    }
  } catch {
    // fall through
  }
  return pathname;
}

export function recipePathAllowsPending(path) {
  return (
    /^\/recipe\/[1-9]\d*$/.test(path) ||
    /^\/recipe\/[1-9]\d*\?src=magazine$/.test(path)
  );
}
